<div class="card block isMinimizable">
    <div class="card-header">
        <div class="card-title">
            <i class="fa fa-angle-up"></i>
            <h2>Rendement par typologie
                <i class="fa fa-info-circle"
                   matTooltip="Rendement brut = loyer annuel moyen / (prix d'achat + {{ notaryRate * 100 }} % de frais de notaire).
Le loyer et la surface moyenne proviennent des annonces de location, le prix au m² des ventes enregistrées par les notaires. Les charges, la vacance locative et la fiscalité ne sont pas prises en compte."></i>
            </h2>
        </div>
    </div>
    <div class="card-body col-12">
        <img *ngIf="preview" src="assets/widgets/ss_loyer_moyen.PNG" class="img-fluid"/>
        <div class="card-text row" *ngIf="!preview">
            <div class="col-12">
                <mat-form-field [ngClass]="{'no_plan' : !authenticationService.isAllowed('basique')}">
                    <mat-label>Exploitation</mat-label>
                    <mat-select disableOptionCentering [(ngModel)]="furnish" (ngModelChange)="edit($event, 'furnish')">
                        <mat-option [value]="0">Tous confondu</mat-option>
                        <mat-option [disabled]="!cityService.hasFurnish(favorite.ad_city, 1)" [value]="1">Meublé</mat-option>
                        <mat-option [disabled]="!cityService.hasFurnish(favorite.ad_city, 2)" [value]="2">Nu</mat-option>
                        <mat-option [disabled]="!hasColoc" [value]="4">Colocation</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div echarts [options]="options" [merge]="data" class="chart" (chartInit)="onChartInit($event)"></div>
        </div>
    </div>
</div>
